import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Globe, Zap } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-74">
      {/* Tech background elements */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoNTksIDEzMCwgMjQ2LCAwLjA1KSIvPjwvc3ZnPg==')] [mask-image:linear-gradient(to_bottom,transparent,black,transparent)] pointer-events-none" data-id="element-75" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-77">
          <div className="inline-flex items-center justify-center p-3 bg-blue-500/10 rounded-2xl mb-6" data-id="element-78">
            <Cpu className="w-8 h-8 text-blue-400" data-id="element-79" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-80">
            La solución se llama <br className="hidden md:block" data-id="element-81" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400" data-id="element-82">
              Arbitraje de Micro-tareas con IA.
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-83">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-7 space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-84">
            <p data-id="element-85">
              No necesitás crear el próximo Facebook. Solo necesitás aprender a
              identificar tareas que a un cliente en EE.UU. o Europa le parecen
              "pequeñas" ($20 USD), pero que para vos significan días de
              supermercado.
            </p>
            <p className="p-6 bg-blue-900/10 border border-blue-500/20 rounded-xl text-white font-medium" data-id="element-86">
              Usamos la Inteligencia Artificial como tu empleado invisible para
              realizar tareas de alta demanda en minutos, saltando la barrera
              del idioma y la falta de experiencia técnica.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-5 grid grid-cols-1 gap-4" data-id="element-87">
            <div className="bg-[#0a0f1a] border border-gray-800 p-5 rounded-xl flex items-center gap-4" data-id="element-88">
              <Globe className="w-8 h-8 text-blue-400 shrink-0" data-id="element-89" />
              <div data-id="element-90">
                <h4 className="text-white font-bold" data-id="element-91">Clientes Globales</h4>
                <p className="text-sm text-gray-400" data-id="element-92">
                  Pagan en dólares por velocidad
                </p>
              </div>
            </div>
            <div className="bg-[#0a0f1a] border border-gray-800 p-5 rounded-xl flex items-center gap-4" data-id="element-93">
              <Cpu className="w-8 h-8 text-emerald-400 shrink-0" data-id="element-94" />
              <div data-id="element-95">
                <h4 className="text-white font-bold" data-id="element-96">IA como Motor</h4>
                <p className="text-sm text-gray-400" data-id="element-97">
                  Ejecuta el trabajo en minutos
                </p>
              </div>
            </div>
            <div className="bg-[#0a0f1a] border border-gray-800 p-5 rounded-xl flex items-center gap-4" data-id="element-98">
              <Zap className="w-8 h-8 text-yellow-400 shrink-0" data-id="element-99" />
              <div data-id="element-100">
                <h4 className="text-white font-bold" data-id="element-101">Tu Beneficio</h4>
                <p className="text-sm text-gray-400" data-id="element-102">
                  Cobrás la diferencia (Arbitraje)
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}